<div class="nav-bar-container" fxLayout="row" fxLayoutAlign="space-between">
  <span fxLayout="row">
    <span class="site-title" routerLink="/">ottoti</span>
    <span class="site-nav-tray" fxLayout="row">
      <span class="site-nav-button" routerLink="/">Home</span>
      <span class="site-nav-button" routerLink="/games">Games</span>
      <span class="site-nav-button" routerLink="/apps">Apps</span>
      <span class="site-nav-button" routerLink="/tutorials">Tutorials</span>
      <span class="site-nav-button" routerLink="/blog">Blog</span>

    </span>
  </span>

  <span fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px;">
    <span class="site-nav-button" routerLink="/contact">Contact</span>
    <span class="site-nav-button" routerLink="/about">About</span>
    <!-- <span>
      <form [formGroup]="searchForm">
        <mat-form-field appearance="outline">
          <input matInput placeholder="Search">
        </mat-form-field>
      </form>
    </span> -->
    <span>
      <img style="height: 24px" src="../../../assets/images/youtube_social_icon_white.png">
    </span>
  </span>

</div>